import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from './action-button.jsx';
import {
  MidnightDownArrowIcon,
  MidnightUpArrowIcon,
} from '@src/images/image-imports.js';

/**
 * Renders a button with an arrow pointing up or down based on the provided
 * open prop and calls the provided clickHandler when clicked.
 */
const DropdownButton = ({ children, open, clickHandler, className, disabled, hidden, tabIndex }) => {
  let classList = 'filter-button';

  if (disabled) {
    classList += ' disabled';
  }

  if (hidden) {
    classList += ' hidden';
  }

  if (className) {
    classList += ` ${className}`;
  }

  return (
    <ActionButton
      className={classList}
      clickHandler={clickHandler}
      disabled={disabled}
      tabIndex={tabIndex}
    >
      {children}
      <div className='filter-icon'>
        {open ? <MidnightUpArrowIcon /> : <MidnightDownArrowIcon />}
      </div>
    </ActionButton>
  );
}

DropdownButton.propTypes = {
  /**
   * determines if an up or down arrow is shown (true results in an up arrow)
   */
  open: PropTypes.bool.isRequired,
  /**
   * the callback function for when the button is clicked
   */
  clickHandler: PropTypes.func.isRequired,
  /**
   * additional classes to add to the button
   */
  className: PropTypes.string,
  /**
   * whether or not the dropdown should be visually disabled and unable to be clicked
   */
  disabled: PropTypes.bool,
  /**
   * the tabindex for the button
   */
  tabIndex: PropTypes.number,
  /**
   * controls whether dropdown is visible or hidden
   */
  hidden: PropTypes.bool,
};

DropdownButton.defaultProps = {
  open: false,
  disabled: false,
  tabIndex: 0,
};

export default DropdownButton;
